import DATE_FORMATS from '../constants/dateFormats';
import { isEmpty } from './helper';
import { format as dateFnsFormat, isValid, parse } from 'date-fns';
import { getFormat24 } from 'reducers/TimeReducer';
import { DATE_ONLY_REGEX } from '../constants/regex';

/**
 * Formats a date for API or UI.
 *
 * @param {Date|string} date
 * @param {string} format
 * @returns {string|null}
 */

export const formatDate = (date, format = DATE_FORMATS.YYYY_MM_DDTHH_mm_ss, fallback = null) => {
  if (isEmpty(date) || !isValid(new Date(date))) {
    return fallback;
  }
  return dateFnsFormat(new Date(date), format);
};

export const formatTime = (date) => {
  const format24 = getFormat24();
  const format = !format24 ? DATE_FORMATS.hh_mm_a : DATE_FORMATS.HH_mm;
  return formatDate(date, format);
};

export const formatDateTime = (date) => {
  const format24 = getFormat24();
  const format = !format24 ? DATE_FORMATS.MM_DD_YYYY_HH_mm_A : DATE_FORMATS.MM_DD_YYYY_HH_mm;
  return formatDate(date, format);
};

export const formatDisplayDate = (date, format = DATE_FORMATS.MM_DD_YYYY, fallback = null) => {
  if (isEmpty(date)) {
    return fallback;
  }

  let parsedDate;

  // Date-only value from API: "2026-09-24"
  if (typeof date === 'string' && DATE_ONLY_REGEX.test(date)) {
    parsedDate = parse(date, DATE_FORMATS.yyyy_MM_dd, new Date());
  } else {
    parsedDate = new Date(date);
  }

  if (!isValid(parsedDate)) {
    return fallback;
  }

  return dateFnsFormat(parsedDate, format);
};
